export default __webpack_public_path__ + "static/media/mario14.30da72fc.jpg";